import React, { useCallback, useEffect, useState } from 'react'
import ContentHeading from '../../../components/layout/content/ContentHeading'
import InputTextField from '../../../components/input/inputTextField'
import { RemoveRedEyeOutlined, SearchOutlined } from '@mui/icons-material';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Grid, Typography } from '@mui/material';
import { routeName } from '../../../routes/routeName';
import { CardOnlineCourses } from './online-courses';
import { setLoading, unsetLoading } from '../../../store/loading/loading.slice';
import { PublishOnlineCourseApi } from '../../../api/publish-online-course/publish-online-course.api';

export default function ListOnlineCourses() {
  const navigate: NavigateFunction = useNavigate();
  const { t } = useTranslation();
  const [data, setData] = useState<any[]>([{}]);
  const dispatch = useDispatch();
  const [search, setSearch] = useState<any>('')
  const [page, setPage] = useState<number>(1);
  const [pageLimit, setPageLimit] = useState<number>(10);
  const [totalItems, setTotalItems] = useState<number>(0);
  const [sortBy, setSortBy] = useState<string>("");
  const [sortType, setSortType] = useState<string>("ASC");
    const [type, setType] = useState<any>('')

  const loadData = useCallback(async () => {
    dispatch(setLoading());

    try {
      let condition: any = {};
      if (page) condition = { ...condition, page: page };
      if (pageLimit) condition = { ...condition, limit: pageLimit };
      if (search) condition = { ...condition, keyword: search };
      if (type) condition = { ...condition, id_type: type };
      if (search) condition = { ...condition, keyword: search };
      if (sortBy) condition = { ...condition, sort: sortBy };

      const res = await PublishOnlineCourseApi.list(condition);
      const data = res.data
      if (data?.status < 300) {
        setData(data?.data.items);
        setPage(data?.data?.meta.currentPage)
        setTotalItems(data?.data?.meta?.totalItems)
        dispatch(unsetLoading());
      } else {
        dispatch(unsetLoading());
      }
    } catch (error) {
      dispatch(unsetLoading());
    }
  }, [page, pageLimit, sortBy, search, type]);

  useEffect(() => {
    loadData();
  }, [loadData]);
  return (
    <div>
      {/* <ContentHeading
        title={t("ห้องสมุด E-Thesis")}
        detail={t("กรุณาเลือกรายการที่ท่านต้องการ")}
      /> */}

      <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
        <article className="w-full col-span-12 md:col-span-4 lg:col-span-3 sm:col-span-12">
          <InputTextField
            startAdornment={<SearchOutlined />}
            placeholder={t("ค้นหา ชื่อหมวดหมู่วิทยานิพนธ์")}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
              // handleChangeValueSearch("leave_type_name", e.target.value);
              setSearch(e.target.value)
            }}
            value={search || ''}
          />
        </article>


      </div>

      <section className="w-full mt-10">
        <Grid container spacing={2}>
          {data?.map((item: any, index: number) => {
            return (
              <Grid item lg={12 / 6} key={index}>
                <CardOnlineCourses item={item} getData={loadData}/>
              </Grid>
            )
          })}

        </Grid>
      </section>

    </div>
  )
}
